import React, {useState} from 'react'
import TermsOfServiceModal from '../common/TermsOfServiceModal'
import PrivacyPolicyModal from '../common/PrivacyPolicyModal'

const AppFooter = () => {
  const [modalState, setModalState] = useState({
    termsModalOpen: false,
    privacyModalOpen: false
  })

  return (
    <>
      <div className="flex flex-col gap-4 justify-items-center py-8 text-sm">
        <div className="flex flex-row justify-center gap-4">
          <a
            className="link link-neutral"
            onClick={() => {
              setModalState({
                termsModalOpen: true,
                privacyModalOpen: false
              })
            }}
          >
            Terms of Service
          </a>
          <a
            className="link link-neutral"
            onClick={() => {
              setModalState({
                termsModalOpen: false,
                privacyModalOpen: true
              })
            }}
          >
            Privacy Policy
          </a>
        </div>
        <div className="flex flex-row justify-center">
          &copy; Placemakr {new Date().getFullYear()}
        </div>
      </div>
      <TermsOfServiceModal
        isOpen={modalState.termsModalOpen}
        onClose={() => {
          setModalState({
            termsModalOpen: false,
            privacyModalOpen: false
          })
        }}
      />
      <PrivacyPolicyModal
        isOpen={modalState.privacyModalOpen}
        onClose={() => {
          setModalState({
            termsModalOpen: false,
            privacyModalOpen: false
          })
        }}
      />
    </>
  )
}

export default AppFooter
